<template>
  <el-dialog title="以下记录未能匹配" :visible="visible" @close="handleClose" class="unmatched-students-dialog">
    <div class="unmatched-text">{{ localText }}</div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'MobileUnmatchedStudentsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    localText: {
      get() {
        return this.text;
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    handleConfirm() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped>
/* 未能匹配学生弹窗样式 */
.unmatched-students-dialog ::v-deep .el-dialog {
  margin: 60px 10px 10px 10px !important;
  width: calc(100% - 20px) !important;
}

/* 弹窗主体内边距 */
.unmatched-students-dialog ::v-deep .el-dialog__body {
  padding: 15px !important;
}

/* 弹窗头部样式 */
.unmatched-students-dialog ::v-deep .el-dialog__header {
  padding: 15px 20px !important;
}

/* 对话框底部按钮样式 */
.dialog-footer ::v-deep .el-button {
  border-radius: 10px !important; /* 底部按钮圆角与规范一致 */
}

/* 未能匹配文本样式 */
.unmatched-text {
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>